module.exports = __webpack_public_path__ + "static/media/Photo6.7fcae2d1.jpg";